/**
 * Conflicts Query Hook (Epic C-4 — Bezetting & conflicten, Story C-4.3)
 *
 * Eigen bestand, zelfde query-keys-factory-conventie als
 * `usePlanningBoard.ts`/`useOccupancy.ts` (AD-9/AD-18). Consumeert
 * `planningApi.getConflicts` (C-4.2). Een gewone TanStack-`useQuery` —
 * GEEN SSE/websocket-subscriptie (AD-12, architectuurgrens, AC 4 van C-4.3).
 *
 * De undo-mutatie (Story C-4.3, AC 2) is bewust GEEN aparte hook hier —
 * "ongedaan maken" is gewoon een nieuwe `upsertAssignment`-aanroep
 * (`usePlanningBoard.ts`'s `useUpsertAssignment`), hergebruikt door de
 * caller (`PlanbordPage.tsx`) zelf.
 */

import { useQuery } from '@tanstack/react-query';
import { planningApi } from '../../../lib/planningApi';

export const conflictsKeys = {
  all: ['planningConflicts'] as const,
  conflicts: (van: string, tot: string, departmentId?: number) => [...conflictsKeys.all, van, tot, departmentId ?? null] as const,
};

export function useConflicts(van: string, tot: string, departmentId?: number) {
  return useQuery({
    queryKey: conflictsKeys.conflicts(van, tot, departmentId),
    queryFn: () => planningApi.getConflicts(van, tot, departmentId),
    enabled: !!van && !!tot,
  });
}
